import JsBarcode from 'jsbarcode'
import { notice } from '@/components/pbo/notice'
import { ProductManagementRow } from '../queries/useGetProductManagementList'

// 1.0 PRINT 실기능 파리티 — PrintOption 용지 사양별 CODE128 라벨을 인쇄 창으로 렌더한다.
// BarcodePrintModal.tsx 에서 옮겨왔다: 모달 UI 는 컨덕터 생성본이 그리고, 인쇄 동작만 배선이 쓴다.

// 사양별 그리드 — 1.0 PrintOption 용지 분기 대응 (3X8=24라벨/장, 3X4=12라벨/장, A4(바코드)=1열 대형)
const SPEC_LAYOUT: Record<string, { columns: number; labelHeightMm: number }> = {
  'A4(3X8)': { columns: 3, labelHeightMm: 34 },
  'A4(3X4)': { columns: 3, labelHeightMm: 69 },
  'A4(바코드)': { columns: 1, labelHeightMm: 60 },
  // TODO(dev): '라벨(1X2)' 는 데모에 새로 생긴 사양 — 1.0 PrintOption 에 대응 규격이 없어 실측 필요.
  //   확정 전까지 셸 옵션에서 뺀다(PRINT_SPEC_OPTIONS). 미정의 사양이 들어오면 A4(3X8) 그리드로 폴백한다.
}
/** 사양 미선택·미정의 사양일 때 쓰는 기본 용지(1.0 PrintOption 기본과 같다). */
export const DEFAULT_PRINT_SPEC = 'A4(3X8)'
/** 바코드 출력 모달 규격 셀렉트 선택지 — 그리드가 정의된 사양만. */
export const PRINT_SPEC_OPTIONS = Object.keys(SPEC_LAYOUT).map((v) => ({ value: v, label: v }))

// GDS_NM/GDS_CD/BARCODE 는 셀 편집(cellEdit)·엑셀 업로드로 임의 입력 가능 — document.write 전 반드시 이스케이프 (XSS 방지)
const escapeHtml = (value: string): string =>
  value.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c] ?? c)

const barcodeSvg = (value: string): string => {
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
  try {
    JsBarcode(svg, value, { format: 'CODE128', displayValue: true, fontSize: 12, height: 40, margin: 4 })
  } catch {
    // 실패 경로도 원문 삽입 금지 — BARCODE 이스케이프
    return `<div class="invalid">잘못된 바코드: ${escapeHtml(value)}</div>`
  }
  svg.setAttribute('preserveAspectRatio', 'xMidYMid meet')
  svg.style.maxWidth = '100%'
  svg.style.maxHeight = '70%'
  return svg.outerHTML
}

/** 선택 행의 바코드 라벨을 인쇄 창으로 연다. copies = 라벨 반복 매수(데모 신설 필드, 기본 1). */
export const openPrintWindow = (rows: ProductManagementRow[], spec: string, copies = 1) => {
  const layout = SPEC_LAYOUT[spec] ?? SPEC_LAYOUT[DEFAULT_PRINT_SPEC]
  const printable = rows.filter((r) => r.BARCODE)
  const one = (r: ProductManagementRow) => `
      <div class="label">
        ${barcodeSvg(r.BARCODE)}
        <div class="name">${escapeHtml(r.GDS_NM ?? '')}</div>
        <div class="code">${escapeHtml(r.GDS_CD ?? '')}</div>
      </div>`
  const labels = printable.flatMap((r) => Array.from({ length: Math.max(1, copies) }, () => one(r))).join('')
  const win = window.open('', '_blank', 'width=900,height=1200')
  if (!win) {
    notice.failure('팝업이 차단되어 인쇄 창을 열 수 없습니다.')
    return
  }
  win.document.write(`<!doctype html><html><head><title>바코드 프린트 (${escapeHtml(spec)})</title>
    <style>
      @page { size: A4; margin: 8mm; }
      body { margin: 0; font-family: 'Pretendard', sans-serif; }
      .sheet { display: grid; grid-template-columns: repeat(${layout.columns}, 1fr); gap: 2mm; }
      .label { height: ${layout.labelHeightMm}mm; border: 0.2mm dashed #ccc; display: flex; flex-direction: column;
               align-items: center; justify-content: center; overflow: hidden; padding: 1mm; box-sizing: border-box;
               break-inside: avoid; text-align: center; }
      .name { font-size: 10px; width: 100%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
      .code { font-size: 9px; color: #555; }
      .invalid { color: red; font-size: 10px; }
    </style></head><body><div class="sheet">${labels}</div></body></html>`)
  win.document.close()
  win.focus()
  // 렌더 완료 후 인쇄 다이얼로그 — 인쇄/취소 후 창은 사용자가 닫는다 (1.0 동일 UX)
  win.onload = () => win.print()
}
